/** 3-dot menu for a chart card, mirroring VivoPlots' PlotControls "Export" action. */
import { Dropdown } from "antd";
import { DownloadOutlined, EllipsisOutlined } from "@ant-design/icons";
import { downloadChartSvg } from "./chartBase";
import type { PlotDownloadMenuProps } from "./onboardingPlots.types";

export default function PlotDownloadMenu({
  containerId,
  title,
  hint,
  legendItems = [],
}: PlotDownloadMenuProps) {
  return (
    <Dropdown
      menu={{
        items: [
          {
            key: "download",
            label: (
              <div className="flex items-center gap-2">
                <DownloadOutlined />
                Export
              </div>
            ),
            onClick: () =>
              downloadChartSvg(containerId, title, { hint, legendItems }),
          },
        ],
      }}
    >
      <button
        type="button"
        aria-label="Plot menu"
        className="flex h-5 w-5 items-center justify-center rounded-sm text-[#2B4752]"
      >
        <EllipsisOutlined style={{ fontSize: "18px" }} />
      </button>
    </Dropdown>
  );
}
